
import { subject } from '@casl/ability';
import abilityBuild from '../../../../../shared/CASL/appAbility';
import { DefaultButton, Dialog, DialogFooter, DialogType, DocumentCard, DocumentCardActions, DocumentCardDetails, DocumentCardType, getTheme, IDocumentCardStyles, ITheme, Label, List, mergeStyleSets, PrimaryButton, Text, Link, IButtonProps, TooltipHost } from '@fluentui/react';
import { useBoolean } from '@fluentui/react-hooks';
import { Toast, ToastMessageType } from 'primereact/toast';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import protocolliFascicoliService from '../../../../../services/protocolliFascicoli.service';
import { Protocol_State } from '../../../../../shared/enums';
import { IFascicolo, IProtocol } from '../../../../../shared/interfaces';
import { reduxActions, RootState } from '../../../../../store';
import CircleLoader from '../../../../Loader/CircleLoader/CircleLoader';
import { store } from '../../../../..';

const queryString = require('query-string');

const theme: ITheme = getTheme();
const { fonts } = theme;


const documentCardSyles: Partial<IDocumentCardStyles> = {
    root: {
        height: 50,
        '& .ms-DocumentCardDetails': {

            display: 'flex', flexFlow: 'column', justifyContent: 'center', padding: '0 15px'
        },
        '& .ms-DocumentCardActions': {

            display: 'flex', flexFlow: 'column', justifyContent: 'center', 'height': 'unset'
        }

    },

}

const classNames = mergeStyleSets({
    itemName: [
        fonts.medium,
        {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            width: '100%'

        },
    ],
    label: {
        paddingLeft: 25,
        paddingRight: 25
    },
    loader: {
        'z-index': 999999999999
    }
});

export interface FascicoliDiProtocolloProps {
    currentProtocol: IProtocol
    forceFascicoliRefresh?: boolean
    onDeleteFascicolo: (deleteMessage: ToastMessageType) => void
    extraCssClass?: string
}

type Props = FascicoliDiProtocolloProps & RouteComponentProps

const FascicoliDiProtocollo: React.FunctionComponent<Props> = (props) => {

    const selectCurrentAoo = (state: RootState) => state.sessionReducer.currentAoo;
    const currentAoo = useSelector(selectCurrentAoo);
    const selectCurrentUor = (state: RootState) => state.sessionReducer.currentUor;
    const currentUor = useSelector(selectCurrentUor);

    const [loading, { setFalse: hideLoading, setTrue: showLoading }] = useBoolean(false);
    const [fascicoli, setFascicoli] = useState<IFascicolo[]>([]);

    const [isConfirmDialogOpen, { setTrue: showConfirmDialog, setFalse: dismissConfirmDialog }] = useBoolean(false);
    const [submitConfirmDialog, setSubmitConfirmDialog] = useState(() => () => { });


    useEffect(() => {
        showLoading();
        protocolliFascicoliService.getFascicoliDelProtocollo(currentAoo!.id, props.currentProtocol.protocolId!, currentUor?.id)
            .then(result => {
                setFascicoli(result);
                hideLoading();
            });

    }, [props.forceFascicoliRefresh])


    const deleteFascicoloConfirmDialogSubmit = (ev, item: IFascicolo) => {
        showLoading();
        protocolliFascicoliService.rimuoviProtocolloDalFascicolo(currentAoo!.id, currentUor!.id!, props.currentProtocol.protocolId!, item.id)
            .then(result => {
                //non faccio hideLoading qua perchè in props.onDeleteReference forzo il reload dei fascicoli
                props.onDeleteFascicolo({ severity: 'info', summary: `Fascicolo ${item.descrizione}`, detail: "Eliminato correttamente", life: 5000 });

            }, error => {
                if (!error.isErrorShown) {
                    props.onDeleteFascicolo({ severity: 'error', summary: 'Attezione', detail: "Errore nella rimozione del fascicolo", life: 5000 });
                }


            });
        dismissConfirmDialog();

    }

    const closeConfirmDialog = () => {
        setSubmitConfirmDialog(() => () => { })
        dismissConfirmDialog();
    }

    const onRenderFascicoloCell = (item) => {
        let fascicolo = { ...item } as IFascicolo;
        let actions: IButtonProps[] = [];
        let path;

        if (props.currentProtocol && props.currentProtocol.statoProtocollo === Protocol_State.Protocollato
            && abilityBuild.can('update', subject('IProtocol', props.currentProtocol))
            && !fascicolo.dataChiusura && fascicolo.idPdVConservazione === undefined) {
            actions.push(
                {
                    iconProps: { iconName: 'Delete' },
                    onClick: (ev) => {
                        ev.stopPropagation();
                        ev.preventDefault();
                        setSubmitConfirmDialog(() => () => { deleteFascicoloConfirmDialogSubmit(ev, fascicolo) })
                        showConfirmDialog()
                    },
                    ariaLabel: 'Elimina',
                }
            );
        }
        else if (props.currentProtocol && props.currentProtocol.statoProtocollo === Protocol_State.Protocollato
            && fascicolo.dataChiusura) {
            actions.push(
                {
                    iconProps: { iconName: 'Lock' },
                    onClick: (ev) => {
                        ev.stopPropagation();
                        ev.preventDefault();
                    },
                    ariaLabel: '',
                }
            );
        }
        else if (props.currentProtocol && props.currentProtocol.statoProtocollo === Protocol_State.Protocollato
            && fascicolo.idPdVConservazione !== undefined) {
            actions.push(
                {
                    iconProps: { iconName: 'Archive' },
                    onClick: (ev) => {
                        ev.stopPropagation();
                        ev.preventDefault();
                    },
                    ariaLabel: '',
                }
            );
        }


        return (
            <DocumentCard
                type={DocumentCardType.compact}
                styles={documentCardSyles}

            >
                <DocumentCardDetails >
                    <TooltipHost content={fascicolo.fascicoloLabel} >

                        <Link
                            id={fascicolo.id.toString()}
                            className={classNames.itemName}
                            onClick={() => {
                                store.dispatch(reduxActions.appNavigationActions.setFascicolo(fascicolo));
                                let path = `/${currentAoo?.id}/fascicoli/${fascicolo.id}`;
                                props.history.push({ pathname: path, search: props.location.search });
                            }}>
                            {fascicolo.fascicoloLabel}
                        </Link>

                    </TooltipHost>
                </DocumentCardDetails>
                <DocumentCardActions
                    actions={actions} />

            </DocumentCard>
        );
    }



    /*return <div style={{ paddingTop: 10, paddingLeft: 5, paddingRight: 5, fontSize: 16 }}></div>;*/
    return (
        <div className={`flex flex-column position-relative ${props.extraCssClass}`}>
            <CircleLoader loaderClass='loader-large' loading={loading} />
            <div className={`references-box flex flex-column overflow-hidden`} >
                <Label className={classNames.label}>Fascicoli del protocollo</Label>
                <div className={`position-relative my-scroll-div`}>
                    <div className={`my-component-content`}>
                        {
                            fascicoli && fascicoli.length > 0
                                ?
                                <List items={fascicoli} onRenderCell={onRenderFascicoloCell} />
                                :
                                <div style={{ marginLeft: '31px' }}>
                                    <Text> Il protocollo non è stato inserito in alcun fascicolo. </Text>
                                </div>
                        }
                    </div>
                </div>
            </div>

            <Dialog
                hidden={!isConfirmDialogOpen}
                onDismiss={closeConfirmDialog}
                dialogContentProps={{

                    type: DialogType.normal,
                    title: 'Conferma',
                    closeButtonAriaLabel: 'Close',
                    subText: `Vuoi rimuovere il protocollo da questo fascicolo?`,
                }}
            >
                <DialogFooter>
                    <PrimaryButton onClick={submitConfirmDialog} text="Conferma" />
                    <DefaultButton onClick={closeConfirmDialog} text="Annulla" />
                </DialogFooter>

            </Dialog>

        </ div>

    );
};


export default FascicoliDiProtocollo;